import { Turbo } from "@hotwired/turbo-rails"
import { Application } from 'stimulus'
import { registerControllers } from 'stimulus-vite-helpers'
import 'bootstrap'
import LocalTime from "local-time"

const application = Application.start()
const controllers = import.meta.glob('../controllers/*_controller.js', { eager: true })
registerControllers(application, controllers)

import { createConsumer } from '@rails/actioncable'
window.cable = createConsumer()

Turbo.start()
LocalTime.start()
